class BarcodeMaterialItem {
  constructor({
    materialID,
    materialCode,
    mainGroup,
    materialDesc,
    barcode,
    verticalId,
    chart,
    shade,
    sizex,
    initialQty,
    balanceQty,
    division,
    grade,
    serialB,
    dateofUpload,
    orgDivision,
    brand,
    category,
    subCategory,
    sleevesPleat,
    fit,
    season,
    fabricType,
    wearType,
    exMill,
    wholeSale,
    MRP,
    materialVertical,
    stockType,
    status,
    created_at
  }) {
    this.materialID = materialID;
    this.materialCode = materialCode;
    this.mainGroup = mainGroup;
    this.materialDesc = materialDesc;
    this.barcode = barcode;
    this.verticalId = verticalId;
    this.chart = chart;
    this.shade = shade;
    this.sizex = sizex;
    this.initialQty = initialQty;
    this.balanceQty = balanceQty;
    this.division = division;
    this.grade = grade;
    this.serialB = serialB;
    this.dateofUpload = dateofUpload;
    this.orgDivision = orgDivision;
    this.brand = brand;
    this.category = category;
    this.subCategory = subCategory;
    this.sleevesPleat = sleevesPleat;
    this.fit = fit;
    this.season = season;
    this.fabricType = fabricType;
    this.wearType = wearType;
    this.exMill = exMill;
    this.wholeSale = wholeSale;
    this.MRP = MRP;
    this.materialVertical = materialVertical;
    this.stockType = stockType;
    this.status = status;
    this.created_at = created_at;
  }
}
export default BarcodeMaterialItem;
